import { useFrame } from '@react-three/fiber';
import { group } from '../../sagas/helpers/saga.camera';
import { useCameraPos } from './Three.hooks';

export const CameraAnimation = () => {
  // Custom hook for managing camera position (assuming it sets the camera position).
  useCameraPos();

  // React-Three-Fiber's frame loop to update tweens.
  useFrame(() => {
    group.update(); // Ensure TWEEN updates in every frame.
  });

  return null; // This component is used only for managing animations.
};
